import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M21.724 2.835c-.2-1.662-1.6-2.835-3.3-2.835h-14c-1.5 0-2.7 1.075-3 2.444l-1.4 8.798c-.2 1.564.9 3.128 2.5 3.324h5.2v2.932c0 2.151 1.8 3.91 4 3.91.4 0 .8-.195.9-.586l3.7-8.212h2c1.7 0 3.1-1.173 3.3-2.835V2.933c.1 0 .1-.098.1-.098m-7 8.7-3.6 7.918c-.8-.293-1.4-.977-1.4-1.857v-3.91c0-.587-.4-.978-1-.978h-5.9c-.5-.098-.9-.586-.8-1.075l1.4-8.798c.1-.49.5-.88 1-.88h10.3zm5-1.857c-.1.586-.7 1.075-1.3 1.075h-1.7V1.955h1.7c.6-.098 1.2.39 1.3 1.075z"
    }, null, -1)
  ]))]))
}
export default { render: render }